import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand-wrapper">
              <img src="/logo.png" alt="MILAMIA Logo" className="footer-logo-image" />
              <h3 className="footer-brand">MILAMIA</h3>
            </div>
            <p className="footer-tagline">AI-Driven Brand & Business Engineering</p>
            <p className="footer-description">
              Engineering complete ecosystems that enable businesses to operate efficiently,
              scale confidently, and stand out globally through integrated digital, AI, and
              business solutions.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('home')} className="footer-link">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="footer-link">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="footer-link">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-choose')} className="footer-link">
                  Why Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="footer-link">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="footer-link">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Phone size={16} className="footer-contact-icon" />
                <span>+1 786 637 9167</span>
              </li>
              <li className="footer-contact-item">
                <Phone size={16} className="footer-contact-icon" />
                <span>+90 541 354 58 25</span>
              </li>
              <li className="footer-contact-item">
                <Mail size={16} className="footer-contact-icon" />
                <span>support@milamiausa.com</span>
              </li>
              <li className="footer-contact-item">
                <MapPin size={16} className="footer-contact-icon" />
                <span>Miami, Florida 33131</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} MILA MIA USA LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;